import { getAppInfo } from 'util/appInfo';
import { ReactionType } from './types';

const { isT } = getAppInfo();

export const REACTION_DISPLAY_DURATION = 5000; // 5 seconds
export const MAX_VISIBLE_REACTIONS = 15;
export const REACTION_FADE_OUT_DURATION = 400; // Fade out duration in ms

export const REACTIONS_LIST: ReactionType[] = [
    ReactionType.Hello,
    ReactionType.Heart,
    ReactionType.ThumbsUp,
    ReactionType.Clap,
    ReactionType.Party,
    ReactionType.Fire,
    ReactionType.Laugh,
    ReactionType.Thinking,
    ReactionType.Angry,
    ReactionType.ThumbsDown,
    ReactionType.Tears,
    ...(!isT ? [ReactionType.Poop] : []),
];
